import { animate, style, transition, trigger } from '@angular/animations';

export const slideElement = trigger('slideElement', [
    transition('* => animate', [
        style({ transform: 'translateY(40rem)', opacity: 0 }),
        animate(
            '1s linear',
            style({ transform: 'translateY(0)', opacity: 1 })
        )
    ])
]);
